<!--销售系统-->
<template>
  <div class="ss_home flex_row apphome">
    <!-- <leftcolumn class="app5760 flex_column"/> -->
    <div class="left flex_column">
      <div class="top">
        <div class="mybox">
          <div class="title">团队介绍</div>
          <div class="box tdbox">
            <div class="top">
              <DefTree v-bind:tree="treeDatas"></DefTree>
            </div>
            <div class="bottom">
              <NewList3></NewList3>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom flex_column">
        <div class="mybox">
          <div class="title">产品销量排名</div>
          <div class="box">
            <div id="ss_bar4" class="echarts"></div>
          </div>
        </div>
        <div class="mybox">
          <div class="title">销售提示</div>
          <div class="box dwcplist">
            <li v-for="(item, index) in dwcplist" :key="index">
              <span>{{ item.time }}</span>
              <span
                >{{ item.name }}，
                <a href="#" @click="notifyClick(item.id)">点击查看</a>
              </span>
            </li>
          </div>
        </div>
      </div>
    </div>
    <div class="center flex_column">
      <div class="top">
        <div class="mybox">
          <div class="title">销售网络</div>
          <div class="box realtime">
            <div id="regionCharts" style="width: 100%; height: 100%"></div>
            <RealTimeStatus v-if="false"></RealTimeStatus>
          </div>
        </div>
      </div>
      <div class="bottom flex_column">
        <div class="mybox">
          <div class="title">业绩趋势</div>
          <div class="box yjbox">
            <div class="left">
              <div id="ss_line1" class="echarts"></div>
            </div>
            <div class="right">
              <div class="piebox">
                <div id="ss_pie1" class="echarts"></div>
              </div>
              <div class="piebox">
                <div id="ss_pie2" class="echarts"></div>
              </div>
              <div class="piebox">
                <div id="ss_pie3" class="echarts"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="mybox">
          <div class="title">区域占比</div>
          <div class="box">
            <div id="ss_bar1" class="echarts"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="right flex_column">
      <div class="mybox">
        <div class="title">销售明星</div>
        <div class="box">
          <NewList2></NewList2>
        </div>
      </div>
      <div class="mybox">
        <div class="title">销售团队风采</div>
        <div class="box">
          <NewList1></NewList1>
        </div>
      </div>
      <div class="mybox">
        <div class="title">重点客户</div>
        <div class="box">
          <CooperativePartner></CooperativePartner>
        </div>
      </div>
      <div class="mybox">
        <div class="title">渠道分布</div>
        <div class="box clstate">
          <div class="left">
            <div id="regionChartsMap" style="width: 100%; height: 100%"></div>
          </div>
          <div class="right">
            <li v-for="(item, index) in qdlist" :key="index">
              {{ item.name }}：{{ item.value }}
            </li>
          </div>
        </div>
      </div>
    </div>
    <!-- <rightcolumn class="app5760 flex_column"/> -->


    <!-- 销售提示弹框 -->
    <el-dialog
      v-dialogDrag
      title="销售提示"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="35%"
    >
      <div class="sale-propmt">
        <ul>
          <li>
            <span>提示时间</span>
            <span>{{ details.noteTime }}</span>
          </li>
          <li>
            <span>事件类型</span>
            <span>{{ propmtData[details.eventType - 1] }}</span>
          </li>
          <li>
            <span>事件主体</span>
            <span>{{ details.eventBody }}</span>
          </li>
          <li>
            <span>发生区域</span>
            <span>{{ details.eventArea }}</span>
          </li>
          <li>
            <span>事件内容</span>
            <span>{{ details.eventContent }}</span>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
import api from "@/apis/sale/sale";
import DefTree from "@/components/TreeDefault";
import RealTimeStatus from "@/components/RealTimeStatus"; //实时状态
import NewList1 from "@/components/NewList1"; //团队风采
import NewList2 from "@/components/NewList2"; //销售冠军
import NewList3 from "@/components/NewList3"; //团队介绍
import CooperativePartner from "@/components/CooperativePartner"; //重点客户

// import leftcolumn from "@/views/CompanyProfile/leftcolumn.vue";
// import rightcolumn from "@/views/CompanyProfile/rightcolumn.vue";

export default {
  components: {
    RealTimeStatus,
    NewList1,
    NewList2,
    NewList3,
    CooperativePartner,
    DefTree,
    // leftcolumn,
    // rightcolumn,
  },
  data() {
    return {
      qdlist: [], //渠道数据
      propmtData: ["安全提示", "管理提示", "能耗突增", "能耗超标"], //提示类型
      details: "", //详情
      dialogVisible: false, //销售提示弹窗状态
      dwcplist: [],
      treeDatas: "", //树数据
    };
  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  methods: {
    //获取树数据
    getTreeData() {
      api.getStationList().then((res) => {
        if (res.code == 10000) {
          if (res.data.length != 0) {
            this.treeDatas = res.data;
          }
        }
      });
    },
    //获取销售排名数据
    getRank() {
      api.getOrder().then((res) => {
        if (res.code == 10000) {
          let _data = res.data
          let name = [];
          let lastYear = [];
          let thisYear = [];
          for (var i in _data) {
            name.push(_data[i].proName);
            lastYear.push(_data[i].saleDataLast);
            thisYear.push(_data[i].saleData);
          }
          this.ss_bar4(name, lastYear, thisYear);
        }
      });
    },
    //获取销售提示
    getSalePro() {
      api.getNotify().then((res) => {
        if (res.code == 10000) {
          let _data = res.data.list;
          let _arr = _data.map((item) => {
            return {
              id: item.id,
              name: item.eventBody,
              time: item.noteTime,
            };
          });
          this.dwcplist = _arr;
        }
      });
    },
    //销售提示点击事件
    notifyClick(id) {
      api.getNotifyDetail(id).then((res) => {
        if (res.code == 10000) {
          this.details = res.data;
          this.dialogVisible = true;
        }
      });
    },
    //获取业绩趋势
    getTrend() {
      //获取下面的
      api.getAchieveDown().then((res) => {
        if (res.code == 10000) {
          this.ss_pie2(
            "ss_pie1",
            res.data[0].monthData,
            "#24ffb1",
            "本月业绩达成率"
          );
          this.ss_pie2(
            "ss_pie2",
            res.data[0].yearData,
            "#00ccff",
            "全年业绩达成率"
          );
          this.ss_pie2("ss_pie3", res.data[0].face, "#ae74f3", "业绩进步率");
        }
      });
      //获取月份
      api.getAchieve().then((data) => {
        if (data.code == 10000) {
          let _data = data.data;
          let xAxisData = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
          let  seriesData = []

          for (const iterator of _data) {
            seriesData.push(
              {
                name: iterator.proName,
                type: 'line',
                data: [iterator.proName,iterator.oneData,iterator.twoData,iterator.threeData,iterator.fourData,iterator.fiveData,iterator.sixData,iterator.sevenData,iterator.eightData,iterator.nineData,iterator.tenData,iterator.elevenData,iterator.twelveData,]
              }
            )
          }

          this.ss_line(xAxisData,seriesData);
        }
      });
    },
    //获取区域占比
    getAreaZB() {
      api.getArea().then((res) => {
        if (res.code == 10000) {
          let _data = res.data.list;
          let area = [];
          let lastYear = [];
          let thisYear = [];
          for (var i in _data) {
            area.push(_data[i].area);
            lastYear.push(_data[i].saleDataLast);
            thisYear.push(_data[i].saleData);
          }
          this.ss_bar1(area, lastYear, thisYear);
        }
      });
    },
    //获取渠道分布
    getWay() {
      api.getChannel().then((res) => {
        if (res.code == 10000) {
          let _data = res.data.list[0];
          this.qdlist = [
            { id: 0, name: "华中区", value: _data.centralNum },
            { id: 1, name: "华东区", value: _data.eastNum },
            { id: 2, name: "华北区", value: _data.northNum },
            { id: 3, name: "华南区", value: _data.southNum },
            { id: 4, name: "华西区", value: _data.westNum },
          ];
        }
      });
    },
    //获取地图
    drawregionChartsMap() {
      let dataList = [{ name: "四川", value: 1400 }]; // 该数据是从服务器获取到的数据
      let option = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            if (isNaN(params.value)) {
              params.value = 0;
            }
            return params.name + " <br> " + params.value; //自行定义formatter格式
          },
        },
        visualMap: {
          min: 0,
          max: 1500,
          textStyle: {
            color: "#fff", fontSize:this.$echartsFontSize-4,
          },
          left: "30",
          bottom: "30",
          text: ["高", "低"], //取值范围的文字
          inRange: {
            color: ["rgba(0,204,255, 0.4)", "rgba(0,204,255, 1)"], //取值范围的颜色
          },
          show: false, //图注
        },
        geo: {
          map: "china",
          roam: false, //不开启缩放和平移
          zoom: 1, //视角缩放比例
          label: {
            normal: {
              show: false,
              fontSize: this.$echartsFontSize-6,
              color: "#ccd0f2", textShadowBlur:3, textShadowColor:'#000',
            },
            emphasis: {
              textStyle: {
                color: "#fff",
              },
            },
          },
          itemStyle: {
            normal: {
              // areaColor:'rgba(8,41,196, 0.2)',//默认区域颜色
              areaColor:'rgba(0,204,255, 0.2)',//默认区域颜色
              borderColor: "#00ccff",
            },
            emphasis: {
              areaColor: "#00ccff", //鼠标选择区域颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
        series: [
          {
            name: "信息量",
            type: "map",
            geoIndex: 0,
            data: dataList,
          },
        ],
      };
      let mychart = this.$echarts.init(
        document.getElementById("regionChartsMap")
      );
      mychart.setOption(option);
      this.$nextTick(() => {
        mychart.resize(); // 这里是为了解决，tab刷新的时候，图表不刷新的问题。
      });
    },
    //获取地图
    drawregionCharts() {
      var points = [
        {
          name: "德阳市",
          value: [104.436756, 31.128701],
        },
      ];
      let dataList = [
        { name: "陕西", value: 200 },
        { name: "四川", value: 1400 },
        { name: "重庆", value: 100 },
        { name: "贵州", value: 1000 },
        { name: "甘肃", value: 350 },
        { name: "西藏", value: 50 },
        { name: "黑龙江", value: 350 },
        { name: "海南", value: 250 },
        { name: "湖北", value: 500 },
        { name: "新疆", value: 800 },
      ]; // 该数据是从服务器获取到的数据
      let option = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            if (isNaN(params.value)) {
              params.value = 0;
            }
            return params.name + " <br> " + params.value; //自行定义formatter格式
          },
        },
        visualMap: {
          min: 0,
          max: 1500,
          textStyle: {
            color: "#fff", fontSize:this.$echartsFontSize-4,
          },
          left: "30",
          bottom: "30",
          text: ["高", "低"], //取值范围的文字
          inRange: {
            color: ["rgba(0,204,255, 0.4)", "rgba(0,204,255, 1)"], //取值范围的颜色
          },
          show: true, //图注
        },
        geo: {
          map: "china",
          roam: false, //不开启缩放和平移
          zoom: 1.23, //视角缩放比例
          label: {
            normal: {
              show: true,
              fontSize: this.$echartsFontSize-4,
              color: "#ccd0f2", textShadowBlur:3, textShadowColor:'#000',
            },
            emphasis: {
              textStyle: {
                color: "#fff",
              },
            },
          },
          itemStyle: {
            normal: {
              // areaColor:'rgba(8,41,196, 0.2)',//默认区域颜色
              areaColor:'rgba(0,204,255, 0.2)',//默认区域颜色
              borderColor: "#00ccff",
            },
            emphasis: {
              areaColor: "#00ccff", //鼠标选择区域颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
        series: [
          {
            name: "销售网络",
            type: "map",
            geoIndex: 0,
            data: dataList,
          },

          {
            type: "effectScatter",
            coordinateSystem: "geo",
            showEffectOn: "render",
            rippleEffect: {
              color: "#24ffb1",
              period: 2,
              scale: 3,
              brushType: "fill",
            },
            hoverAnimation: true,
            data: points,
          },
          {
            type: "lines",
            zlevel: 2,
            symbol: ["none", "arrow"],
            symbolSize: 7,
            effect: {
              //线特效配置
              show: true,
              period: 4, //动画时间
              trailLength: 0.02,
              symbol: "circle", //特效图形标记
              symbolSize: 4, //特效图形标记大小
              color: "#fff45c", //特效图形标记颜色
            },
            lineStyle: {
              width: 1, //线条宽度
              opacity: 1, //尾迹线条透明度
              curveness: 0.3, //尾迹线条曲直度
              color: "#24ffb1",
            },
            emphasis: {
              lineStyle: {
                width: 2, //线条宽度
              },
            },
            data: [
              {
                name: "德阳市->陕西",
                coords: [
                  [104.436756, 31.128701],
                  [108.95148,34.349582],
                ],
              },
              {
                name: "德阳市->重庆",
                coords: [
                  [104.436756, 31.128701],
                  [106.552566,29.569238],
                ],
              },
              {
                name: "德阳市->黑龙江",
                coords: [
                  [104.436756, 31.128701],
                  [126.546441,45.807982],
                ],
              },
              {
                name: "德阳市->海南",
                coords: [
                  [104.436756, 31.128701],
                  [109.757255,19.160374],
                ],
              },
              {
                name: "德阳市->上海",
                coords: [
                  [104.436756, 31.128701],
                  [121.464139,31.227659],
                ],
              },
              {
                name: "德阳市->西藏",
                coords: [
                  [104.436756, 31.128701],
                  [91.125337,29.656993],
                ],
              },
              {
                name: "德阳市->新疆",
                coords: [
                  [104.436756, 31.128701],
                  [87.591119,43.832598],
                ],
              },
            ],
          },
        ],
      };
      let mychart = this.$echarts.init(document.getElementById("regionCharts"));
      mychart.setOption(option);
      this.$nextTick(() => {
        mychart.resize(); // 这里是为了解决，tab刷新的时候，图表不刷新的问题。
      });
    },
    ss_pie2(id, data, color, text) {
      let ss_pie2 = echarts.init(document.getElementById(id));
      ss_pie2.setOption({
        color: [color],
        tooltip: {
          trigger: "item",
          textStyle: { fontSize: this.$echartsFontSize },
        },
        legend: {
          show: false,
        },
        title: [
          {
            text: text,
            x: "center",
            top: "15%",
            textStyle: {
              color: "#ccd0f2",
              fontSize: this.$echartsFontSize,
              fontWeight: "100",
            },
          },
          {
            text: data + "%",
            x: "center",
            top: "52%",
            textStyle: {
              fontSize: this.$echartsFontSize + 14,
              color: "#fff",
              fontWeight: "600",
            },
          },
        ],
        polar: {
          radius: ["49%", "58%"],
          center: ["50%", "58%"],
        },
        angleAxis: {
          max: 100,
          show: false,
        },
        radiusAxis: {
          type: "category",
        },
        series: [
          {
            type: "bar",
            roundCap: true,
            barWidth: 60,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(255, 255, 255, .2)",
            },
            data: [data],
            coordinateSystem: "polar",
          },
        ],
      });
    },
    //产品销量排名
    ss_bar4(a, b, c) {
      let ss_bar4 = echarts.init(document.getElementById("ss_bar4"));
      ss_bar4.setOption({
        color: ["#00ccff", "#f4af1b"],
        tooltip: {
          trigger: "axis",
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["去年", "今年"],
          left: "center",
          top: '2%',
          textStyle: {
            color: "#fff",
            fontSize: this.$echartsFontSize,
          },
          itemWidth: 15,
          itemHeight: 5,
        },
        grid: { left: '4%',right:'4%',top:'13%',bottom:'4%',containLabel: false},
        xAxis: {
          type: "value",
          show: false,
        },
        yAxis: {
          type: "category",
          show: false,
          data: a,
        },
        series: [
          {
            name: "去年",
            type: "bar",
            barWidth: "20%",
            itemStyle: {
              normal: {
                label: { show: false },
                barBorderRadius: [0, 12, 12, 0],
              },
            },
            data: b,
          },
          {
            name: "今年",
            type: "bar",
            barWidth: "20%",
            barGap: "10%",
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: [10, "-6px"],
                  formatter: "{b}",
                  lineHeight: "15",
                  color: "#000", fontWeight:600,
                  fontSize: this.$echartsFontSize + 4,
                  textShadowColor: "#fff",
                  textShadowBlur: 2,
                  textShadowOffsetX: 1,
                  textShadowOffsetY: 1,
                },
                barBorderRadius: [0, 12, 12, 0],
              },
            },
            data: c,
          },
        ],
      });
    },
    //区域占比
    ss_bar1(t, v, b) {
      let ss_bar1 = echarts.init(document.getElementById("ss_bar1"));
      ss_bar1.setOption({
        tooltip: {
          trigger: "axis",
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["去年/万元", "今年/万元"],
          left: "center",
          top: '2%',
          textStyle: {
            color: "#fff",
            fontSize: this.$echartsFontSize,
          },
          itemWidth: 15,
          itemHeight: 5,
        },
        xAxis: {
          type: "category",
          axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize,interval: 0},
          axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
          axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
          data: t,
        },
        yAxis: {
          axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
          axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
          // splitNumber:5, 
          nameGap:this.$echartsFontSize,
          splitLine:{show:true,lineStyle:this.splitLineStyle},
          axisTick: { show: true ,lineStyle:{color:this.axisLineColor}},
        },
        grid: { left: '2%',right:'2%',top:'22%',bottom:'4%',containLabel: true},
        series: [
          {
            name: "去年/万元",
            type: "bar",
            barWidth: "13%",
            itemStyle: {
              normal: {
                color: "#00f2fe",
                barBorderRadius: [12, 12, 0, 0],
              },
            },
            data: v,
          },
          {
            name: "今年/万元",
            type: "bar",
            barWidth: "13%",
            itemStyle: {
              normal: {
                color: "#f5c74f",
                barBorderRadius: [12, 12, 0, 0],
              },
            },
            data: b,
          },
        ],
      });
      this.$common.moveEcharts(t.length,ss_bar1);
    },
    //业绩趋势
    ss_line(xAxisData,seriesData) {
      let ss_line = echarts.init(document.getElementById("ss_line1"));
      ss_line.setOption(
        {
          color:['#00ccff','#24ffb1','#fff45c','#ff5f8c','#ae74f3',],

          tooltip: {
            trigger: 'axis',
            textStyle:{fontSize: this.$echartsFontSize}
          },
          legend: {
            left: 'center', top:'2%',
            textStyle: {
              color: "#fff",fontSize:this.$echartsFontSize
            },
            itemWidth: 25,itemHeight: 10,
          },
          grid: { left: '4%',right:'6%',top:'22%',bottom:'4%',containLabel: true},
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData,//['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize,interval: 0},
            axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
            axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
          },
          yAxis: {
            axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
            axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
            nameGap:this.$echartsFontSize,
            splitLine:{show:true,lineStyle:this.splitLineStyle},
            axisTick: { show: true ,lineStyle:{color:this.axisLineColor}},
          },
          series:seriesData
      });
      this.$common.moveEcharts(xAxisData.length,ss_line);
    },
  },
  mounted() {
    this.getRank(); //获取销售排名数据
    this.getSalePro(); //获取销售提示
    this.getTrend(); //获取业绩趋势下面的
    this.getAreaZB(); //获取区域占比
    this.getTreeData(); //获取树数据
    this.getWay(); //获取树数据
    this.drawregionCharts(); //获取地图
    this.drawregionChartsMap(); //获取地图
  },
};
</script>

<style>
/* .diy-right-box{
  
} */
</style>
<style lang="less" scoped>
.ss_home {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0 0.5rem 0.5rem;
  & > .left {
    height: 100%;
    overflow: hidden;
    width: 25%;
    & > .top,
    & > .bottom {
      height: 50%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      .mybox {
        flex: 1;
        height: 50%;
        overflow: hidden;
      }
    }
  }
  & > .center {
    height: 100%;
    overflow: hidden;
    width: 50%;
    & > .top,
    & > .bottom {
      height: 50%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      .mybox {
        flex: 1;
        height: 50%;
        overflow: hidden;
      }
    }
  }
  & > .right {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }
  .realtime {
    position: relative;
  }
  .dwcplist {
    // display: flex;
    flex-direction: column;
    padding: 10px 15px;
    li {
      // flex: 1;
      padding: .5rem 15px;
      width: 100%;
      height: 20%;
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      span:nth-child(1) {
        width: 8rem;
        text-align: left;
      }
      span:nth-child(2) {
        flex: 1;
      }
      a {
        color: #24ffb1;
      }
    }
    li:nth-child(even) {
      background: #ffffff10;
    }
  }
  .tdbox {
    display: flex;
    flex-direction: column;
    .top {
      flex: 1; width: 100%; height: 100%; display: flex; justify-content: center; overflow: auto;
    }
    .bottom {
      height: 12.5rem;
    }
  }
  .clstate {
    display: flex;
    flex-direction: row;
    .left {
      width: 60%;
    }
    .right {
      flex: 1;
      padding-left: 2rem;
      color: #24ffb1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      li {
        margin: 13px 0;
      }
    }
  }
  .yjbox {
    display: flex;
    flex-direction: row;
    .left {
      flex: 1;
    }
    .right {
      flex: 1;
      display: flex;
      flex-direction: row;
      padding: 0.3rem;
      .piebox {
        flex: 1;
        margin: 0.3rem;
        background: rgba(3, 15, 97, 0.2);
        border: #555e86 dashed 1px;
        border-radius: 6px;
      }
    }
  }
}
.sale-propmt {
  text-align: center;
  font-size: 0.8rem;
  > ul > li{ border-bottom: #555e86 dashed 1px;}
  > ul > li > span:first-child {
    width: 30%;
    display: inline-block;
    padding: 0.8rem 1.5rem; background: rgba(6, 3, 88, 0.2);
  }
  > ul > li > span:last-child {
    width: 70%; text-align: left;
    display: inline-block;
    padding: 0.8rem 1.5rem;
  }
}
</style>
